<div class="mt-5 ">
    <div>
        <form #indicatorForm="ngForm">
            <div class="grid">
                <div class="lg:col-6 md:col-12  col-12 ">
                    <div class="mb-3 g-c-primary-dark">
                        <label>
                            {{'document_editor_name' | translate }}
                        </label>
                    </div>
                    <!-- in_charge_data_entry_name -->

                    <input disabled readonly [value]="project?.in_charge_data_entry_name||user.name"
                        name="in_charge_data_entry_id" type="text" class="surface-overlay w-12 mb-2" pInputText />
                </div>
                <div class=" lg:col-6   col-12   md:col-12">
                    <div class=" mb-3 g-c-primary-dark ">
                        <label>
                            {{'document_editor_date' | translate }}
                        </label>
                    </div>
                    <input pInputText disabled readonly [value]="project?.created_at | date:'dd/MM/yyyy'" type="text"
                        class="surface-overlay w-12" />
                </div>
            </div>

        </form>
        <p-accordion expandIcon="pi pi-chevron-up" collapseIcon="pi pi-chevron-down">
            <p-accordionTab>
                <ng-template pTemplate="header">
                    <span class="flex align-items-center gap-2 w-full">
                        <i class="fa-solid fa-rectangle-list text-xl g-c-primary-darker"></i>
                        {{'initiative_goals_indicators' | translate }}
                    </span>
                </ng-template>

                @if(project.IS_ALLOWED_TO_UPDATE ||!project.id) {
                <form #goalAndIndicatorForm="ngForm" (ngSubmit)="addProjectStrategicLinkItem()">
                    <div class="flex justify-content-between align-items-center mb-3">
                        <p class="g-c-primary-darker font-bold m-0">{{'goal_and_indicator_required' | translate}}</p>
                        <p-button label="{{'add' | translate }}" type="submit" />
                    </div>
                    <div class="grid">
                        <div class="lg:col-4 md:col-12 col-12">
                            <div class="mb-3 g-c-primary-dark font-bold">
                                <label>{{'pillar' | translate }}</label>
                            </div>
                            <p-dropdown (onChange)="onPillarChange(pillar)" #pillar [options]="pillarsOptions"
                                optionLabel="name" optionValue="id" placeholder="{{'select_pillar' | translate }}" />
                        </div>
                        <div class="lg:col-4 md:col-12 col-12">
                            <div class="mb-3 g-c-primary-dark font-bold">
                                <label>
                                    {{'goal' | translate }}
                                </label>
                            </div>
                            <p-dropdown [options]="filterdGoalsOptions" (onChange)="onGoalChange(strategic_goal_id)"
                                required optionLabel="name" [(ngModel)]="projectStrategicLinkItem.strategic_goal_id"
                                #strategic_goal_id="ngModel" optionValue="id" name="strategic_goal_id"
                                placeholder="{{'select_goal' | translate }}" />
                            @if((strategic_goal_id.invalid&&strategic_goal_id.touched)||(strategic_goal_id.invalid&&isgoalAndIndicatorFormSubmitted)){
                            <span class="text-red-500">
                                {{'field_is_required'|translate}}
                            </span>}
                        </div>
                        <div class="lg:col-4 md:col-12 col-12">
                            <div class="mb-3 g-c-primary-dark font-bold">
                                <label>{{'indicator' | translate }}</label>
                            </div>
                            <p-dropdown required [options]="filterdIndicatorsOptions" required name="strategic_indicator_id"
                                [(ngModel)]="projectStrategicLinkItem.strategic_indicator_id"
                                #strategic_indicator_id="ngModel" ngModel required optionLabel="name" optionValue="id"
                                placeholder="{{'select_indicator' | translate }}" />

                            @if((strategic_indicator_id.invalid &&
                            strategic_indicator_id.touched)||(strategic_indicator_id.invalid&&isgoalAndIndicatorFormSubmitted)){
                            <span class="text-red-500">
                                {{'field_is_required'|translate}}
                            </span>
                            }
                        </div>
                    </div>
                </form>
                }


                <div class="table pt-5">
                    <p-table [class]="dir" [dir]="dir" [value]="projectStrategicLinkItems" [paginator]="true" [rows]="5"
                        [rowsPerPageOptions]="[5, 10, 20]" [tableStyle]="{ 'min-width': '50rem','width':'55%' }">
                        <ng-template pTemplate="header">
                            <tr>
                                <th class="text-center">
                                    {{'goal' | translate}}
                                </th>
                                <th class="text-center">
                                    {{'indicator' | translate}}
                                </th>
                                <th></th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-item let-i="rowIndex">
                            @if(!item.is_deleted)
                            {
                            <tr>
                                <td>
                                    {{item.strategic_goal_name}}
                                </td>
                                <td>
                                    {{item.strategic_indicator_name}}
                                </td>
                                <td>
                                    @if(project.IS_ALLOWED_TO_UPDATE){
                                    <div class="flex justify-content-evenly align-items-center">
                                        <div (click)="confirmValueDelete($event,i)" [pTooltip]="deleteItemToolTip"
                                            tooltipPosition="left" showDelay="500" hideDelay="300"
                                            class="text-red-600 text-2xl flex   cursor-pointer text-lg font-bold ">
                                            <i class="fa-regular fa-trash-can"></i>

                                        </div>
                                    </div>
                                    }
                                </td>
                            </tr>
                            }
                        </ng-template>
                    </p-table>
                </div>

            </p-accordionTab>
        </p-accordion>
        <form [formGroup]="projectForm">
            <div class="mt-5">
                <p-accordion expandIcon="pi pi-chevron-up" collapseIcon="pi pi-chevron-down">
                    <p-accordionTab>
                        <ng-template pTemplate="header">
                            <span class="flex align-items-center gap-2 w-full">
                                <i class="fa-solid fa-rectangle-list text-xl g-c-primary-darker"></i>
                                {{'government_linkage' | translate }}
                            </span>
                        </ng-template>
                        <div formGroupName="ProjectGovLinkForm">
                            <div class="mt-5">
                                <div class="font-bold mb-4 g-c-primary-color">
                                    {{'emirate_associated_goals' | translate}}
                                </div>
                                <div class="grid" formGroupName="emirate_goal">
                                    <div class="md:col-6 col-12">
                                        <textarea formControlName="emirate_goal_description"
                                            placeholder="{{'enter_goal'|translate}}" rows="5" cols="30"
                                            pInputTextarea></textarea>

                                        @if((emirate_goal_description.invalid &&
                                        !emirate_goal_description.pristine)||(isProjectSubmitted&&emirate_goal_description.invalid)){
                                        <div>
                                            <span class="text-red-500">{{'field_is_required'|translate}}</span>
                                        </div>
                                        }
                                        @if(emirate_goal__group.errors?.['EmirateOne']){
                                        <div>
                                            <span class="text-red-500">{{'fieldRequiredWithReference'|translate}}</span>
                                        </div>
                                        }
                                    </div>
                                    <div class="md:col-6  col-12">
                                        <textarea formControlName="emirate_goal_reference"
                                            placeholder="{{'enter_reference'|translate}}" rows=" 5" cols="30"
                                            pInputTextarea></textarea>

                                        @if(emirate_goal__group.errors?.['EmirateTwo']){
                                        <div>
                                            <span class="text-red-500">{{'fieldRequiredWithGoal'|translate}}</span>
                                        </div>
                                        }
                                    </div>
                                </div>





                                <div>
                                    <div class="flex gap-3 align-items-center">
                                        <!-- todo -->
                                        @if(selectedEmirateRef?.reference_file){
                                        <button (click)="showEmirateReferenceFile()" pButton pRipple
                                            class="flex justify-content-between align-items-center">
                                            <i class="fa-solid fa-eye"></i>
                                        </button>
                                        <button (click)="downloadEmirateReferenceFile()" pButton pRipple
                                            class="flex justify-content-between align-items-center">
                                            <span class="mx-2">
                                                {{'download_reference'|translate}}
                                            </span>
                                            <i class="fa-solid fa-circle-down"></i>
                                        </button>
                                        }
                                        @if(project.IS_ALLOWED_TO_UPDATE){
                                        <button (click)="triggerEmirateReferenceFile()" pButton pRipple
                                            class="flex justify-content-between align-items-center">
                                            <span class="mx-2">
                                                {{'upload_reference'|translate}}
                                            </span>
                                            <i class="fa-solid fa-upload"></i>
                                        </button>
                                        }
                                    </div>



                                    <input type="file" (change)="onEmirateReferencechange($event)" hidden
                                        #emirateReferenceFileInpute id="emirateReferenceFileId"
                                        name="emirateReferenceFile" required>

                                    @if(emirateReferenceFile)
                                    {
                                    <div class="flex align-item-center gap-5 shadow-3 w-fit p-3 my-5 border-round-md">
                                        <i [class]="emirateReferenceFileMetaData.icon" class=" text-2xl"
                                            [ngStyle]="{color:emirateReferenceFileMetaData.color}"></i>
                                        <span class="text-green-500">

                                            {{emirateReferenceFileMetaData.name}}
                                        </span>
                                    </div>
                                    }
                                </div>
                            </div>
                            <div class="mt-5" formGroupName="state_goal">
                                <div class="font-bold mb-4 g-c-primary-color">
                                    {{'state_associated_goals' | translate }}
                                </div>
                                <div class="grid">
                                    <div class="md:col-6 col-12">
                                        <textarea formControlName="state_goal_description"
                                            placeholder="{{'enter_goal'|translate}}" rows="5" cols="30"
                                            pInputTextarea></textarea>

                                        @if(state_goal_group.errors?.['stateOne']){
                                        <div>
                                            <span class="text-red-500">{{'fieldRequiredWithReference'|translate}}</span>
                                        </div>
                                        }

                                    </div>
                                    <div class="md:col-6  col-12">
                                        <textarea formControlName="state_goal_reference"
                                            placeholder="{{'enter_reference'|translate}}" rows=" 5" cols="30"
                                            pInputTextarea></textarea>
                                        @if(state_goal_group.errors?.['stateTwo']){
                                        <div>
                                            <span class="text-red-500">{{'fieldRequiredWithGoal'|translate}}</span>
                                        </div>
                                        }

                                    </div>
                                </div>
                                <div>
                                    <div class="flex gap-3">
                                        @if(selectedStateRef?.reference_file){
                                        <button (click)="showStateReferenceFile()" pButton pRipple
                                            class="flex justify-content-between align-items-center">
                                            <i class="fa-solid fa-eye"></i>
                                        </button>

                                        <button (click)="downloadStateReferenceFile()" pButton pRipple
                                            class="flex justify-content-between align-items-center">
                                            <span class="mx-2">
                                                {{'download_reference'|translate}}
                                            </span>
                                            <i class="fa-solid fa-circle-down"></i>
                                        </button>
                                        }

                                        @if(project.IS_ALLOWED_TO_UPDATE){
                                        <button (click)="triggerStateReferenceFileInput()" pButton pRipple
                                            class="flex justify-content-between align-items-center">
                                            <span class="mx-2">
                                                {{'upload_reference'|translate}}
                                            </span>
                                            <i class="fa-solid fa-upload"></i>
                                        </button>
                                        }
                                    </div>
                                    <input (change)="onStateReferenceFilechange($event)" type="file" hidden
                                        #stateReferenceFileInput id="stateReferenceFileId" name="stateReferenceFile"
                                        required>
                                    @if(stateReferenceFile)
                                    {
                                    <div class="flex align-item-center gap-5 shadow-3 w-fit p-3 my-5 border-round-md">
                                        <i [class]="stateReferenceFileMetaData.icon" class=" text-2xl"
                                            [ngStyle]="{color:stateReferenceFileMetaData.color}"></i>
                                        <span class="text-green-500">

                                            {{stateReferenceFileMetaData.name}}
                                        </span>
                                    </div>
                                    }
                                </div>
                                @if(project.id > 0 && project.IS_ALLOWED_TO_UPDATE){
                                <p class="text-red-500 font-medium">
                                    {{'uploadingNewReferenceDeletesOld'|translate}}
                                </p>
                                }

                            </div>
                        </div>
                    </p-accordionTab>
                </p-accordion>
            </div>
            <div class="mt-5">
                <p-accordion expandIcon="pi pi-chevron-up" collapseIcon="pi pi-chevron-down">
                    <p-accordionTab>
                        <ng-template pTemplate="header">
                            <span class="flex align-items-center gap-2 w-full">
                                <i class="fa-solid fa-rectangle-list text-xl g-c-primary-darker"></i>
                                {{'initiative_basic_data' | translate}}
                            </span>
                        </ng-template>
                        <div formGroupName="generalProjectInfoForm">
                            <!-- Name and Weight in one row -->
                            <div class="form-grid mt-2">
                                <div class="form-control">
                                    <label class="form-label">
                                        <i class="fa-solid fa-project-diagram"></i>
                                        {{'initiative_name' | translate}}
                                        <span class="text-red-500 font-bold">*</span>
                                    </label>
                                    <textarea formControlName="name" rows="3" cols="30" pInputTextarea 
                                        placeholder="{{'enter_initiative_name'|translate}}"></textarea>
                                    @if((name_control.invalid &&
                                    !name_control.pristine)||(isProjectSubmitted&&name_control.invalid)){
                                    <span class="field-error">
                                        <i class="fa-solid fa-circle-exclamation"></i>
                                        {{'field_is_required'|translate}}
                                    </span>
                                    }
                                </div>

                                <div class="form-control">
                                    <label class="form-label">
                                        <i class="fa-solid fa-language"></i>
                                        {{'name_in_english' | translate}}
                                    </label>
                                    <textarea formControlName="name_en" rows="3" cols="30" pInputTextarea 
                                        placeholder="{{'enter_initiative_name_en'|translate}}"></textarea>
                                </div>

                                <div class="form-control">
                                    <label class="form-label">
                                        <i class="fa-solid fa-weight-hanging"></i>
                                        {{'weight' | translate}}
                                    </label>
                                    <input formControlName="weight" 
                                           pInputText 
                                           type="number" 
                                           min="0" 
                                           max="100" 
                                           step="1"
                                           (keydown)="onWeightKeyDown($event)"
                                           (input)="onWeightInput($event)"
                                           placeholder="{{'enter_weight'|translate}}" />
                                    @if((weight_control.invalid && !weight_control.pristine) || (isProjectSubmitted && weight_control.invalid)){
                                        <span class="field-error">
                                            <i class="fa-solid fa-circle-exclamation"></i>
                                            @if(weight_control.errors?.['min']){
                                                {{dir == 'rtl' ? 'الوزن يجب أن يكون أكبر من أو يساوي 0' : 'Weight must be greater than or equal to 0'}}
                                            }@else if(weight_control.errors?.['max']){
                                                {{dir == 'rtl' ? 'الوزن يجب أن يكون أقل من أو يساوي 100' : 'Weight must be less than or equal to 100'}}
                                            }@else {
                                                {{'field_is_required'|translate}}
                                            }
                                        </span>
                                    }
                                </div>
                            </div>
                            <div class="mt-2">
                                <div class="mb-3">
                                    <label class="g-c-primary-color font-medium font-bold">
                                        {{'initiative_goal' | translate}}
                                    </label>
                                </div>
                                <textarea formControlName="goals" rows="3" cols="30" pInputTextarea>
                                    </textarea>

                            </div>
                            <div class="mt-2">
                                <div class="mb-3">
                                    <label class="g-c-primary-color font-medium font-bold">
                                        {{'target_audience' | translate}}
                                    </label>
                                </div>
                                <textarea formControlName="target_audience" rows="3" cols="30"
                                    pInputTextarea></textarea>

                            </div>
                            <div class="mt-2">
                                <div class="mb-3">
                                    <label class="g-c-primary-color font-medium font-bold">
                                        {{'initiative_description' | translate}}
                                        <span class="text-red-500 font-bold">*</span>
                                    </label>
                                </div>
                                <textarea formControlName="description" rows="3" cols="30" pInputTextarea>
                                    </textarea>
                                @if((description_control.invalid &&
                                !description_control.pristine)||(isProjectSubmitted&&description_control.invalid)){
                                <div>
                                    <span class="my-1 text-red-500">
                                        {{'field_is_required'|translate}}
                                    </span>
                                </div>
                                }
                            </div>
                            <div class="mt-2">
                                <div class="mb-3">
                                    <label class="g-c-primary-color font-medium font-bold">
                                        {{'description_in_english' | translate}}
                                    </label>
                                </div>
                                <textarea formControlName="description_en" rows="3" cols="30" pInputTextarea>
                                    </textarea>
                            </div>
                            <div class="mt-2">
                                <div class="mb-3">
                                    <label class="g-c-primary-color font-medium font-bold">
                                        {{'initiative_goals' | translate}}
                                    </label>
                                </div>
                                <textarea formControlName="targets" rows="3" cols="30" pInputTextarea></textarea>
                            </div>
                            <div class="mt-2">
                                <div class="mb-3">
                                    <label class="g-c-primary-color font-medium font-bold">
                                        {{'initiative_success_factors' | translate}}
                                    </label>
                                </div>
                                <textarea formControlName="success_factors" rows="3" cols="30"
                                    pInputTextarea></textarea>
                            </div>
                            <div class="mt-2">
                                <div class="mb-3">
                                    <label class="g-c-primary-color font-medium font-bold">
                                        {{'initiative_kpis' | translate}}
                                        <span class="text-red-500 font-bold">*</span>
                                    </label>
                                </div>
                                <textarea formControlName="kpis" rows="3" style="max-width: 100%;"
                                    pInputTextarea></textarea>
                                @if((kpis_control.invalid &&
                                !kpis_control.pristine)||(isProjectSubmitted&&kpis_control.invalid)){
                                <div>
                                    <span class="my-1 text-red-500">
                                        {{'field_is_required'|translate}}
                                    </span>
                                </div>
                                }
                            </div>
                            <div class="mt-2">
                                <div class="mb-3">
                                    <label class="g-c-primary-color font-medium font-bold">
                                        {{'initiative_urgent_need' | translate}}
                                    </label>
                                </div>
                                <textarea formControlName="urgent_need" rows="3" cols="30" pInputTextarea></textarea>
                            </div>
                            <div class="grid mt-3" formGroupName="date_range">
                                <div class="lg:col-6  col-12 ">
                                    <div class="mb-2 g-c-primaryDarkColor font-bold">
                                        <label>
                                            {{'initiative_start_date' | translate}}
                                            <span class="text-red-500 font-bold">*</span>
                                        </label>
                                    </div>
                                    <p-calendar [minDate]="minStartegyDate"
                                        [maxDate]="maxStrategyDate" formControlName="start_date" [iconDisplay]="'input'"
                                        [showIcon]="true" inputId="icondisplay" />
                                    @if((start_date_control.invalid &&
                                    !start_date_control.pristine)||(isProjectSubmitted && start_date_control.invalid)){
                                    <div>
                                        <span class="my-1 text-red-500">
                                            {{'field_is_required'|translate}}
                                        </span>
                                    </div>
                                    }
                                    @if(start_date_control.errors?.['invalidDate']){
                                    <div>
                                        <span class="text-red-500">stetegy date:TODO</span>
                                    </div>
                                    }

                                </div>
                                <div class="lg:col-6  col-12 ">
                                    <div class="mb-2 g-c-primaryDarkColor font-bold">
                                        <label>
                                            {{'initiative_end_date' | translate}}
                                            <span class="text-red-500 font-bold">*</span>
                                        </label>
                                    </div>
                                    <p-calendar [minDate]="minStartegyDate"
                                        [maxDate]="maxStrategyDate" formControlName="end_date" name="end_date"
                                        [iconDisplay]="'input'" [showIcon]="true" inputId="icondisplay" />
                                    @if((end_date_control.invalid &&
                                    !end_date_control.pristine)||(isProjectSubmitted && end_date_control.invalid)){
                                    <div>
                                        <span class="text-red-500">{{'field_is_required'|translate}}</span>
                                    </div>
                                    }

                                </div>
                                @if(date_range_control.errors?.['dateRangeInvalid']){

                                <div class="text-red-500">
                                    {{'The start date must be before the end date'|translate}}
                                </div>
                                }
                            </div>
                        </div>
                    </p-accordionTab>
                </p-accordion>
            </div>
        </form>


    </div>
</div>





@if(isFileViewer){
<p-dialog header="{{selectedFile?.file_name}}" [modal]="true" [(visible)]="isFileViewer" [style]="{ width: '90rem' }"
    [breakpoints]="{ '1199px': '90vw', '575px': '90vw' }" [maximizable]="true">
    <div>
        <web-viewer
            [fileUrl]="viewMode=='emirate'?selectedEmirateRef?.reference_file:selectedStateRef?.reference_file"></web-viewer>
    </div>
</p-dialog>

}














<ng-template #deleteItemToolTip>
    <div class="flex align-items-center">
        <span>{{'remove_link'|translate}}</span>
    </div>
</ng-template>
<p-confirmPopup #confirmPopupRef>
    <ng-template pTemplate="headless" let-message let-test>
        <div class="border-round p-3">
            <span>{{ message.message }}</span>
            <div class="flex align-items-center gap-2 mt-3">
                <p-button i18n-label (click)="accept()" i18n-label label="{{'yes'|translate}}"
                    severity="danger"></p-button>
                <p-button i18n-label (click)="reject()" i18n-label label="{{'no'|translate}}"
                    severity="secondary"></p-button>
            </div>
        </div>
    </ng-template>
</p-confirmPopup>

<!-- Edit Confirmation Dialog -->
<p-dialog [(visible)]="showEditConfirmDialog" [modal]="true" [style]="{width: '30rem'}" [draggable]="false" [resizable]="false">
    <ng-template pTemplate="header">
        <div class="flex align-items-center gap-2">
            <i class="pi pi-exclamation-triangle text-yellow-500 text-2xl"></i>
            <span class="font-bold text-xl">{{'confirm'|translate}}</span>
        </div>
    </ng-template>
    <div class="flex align-items-center gap-3">
        <i class="pi pi-question-circle text-3xl text-primary"></i>
        <span>{{dir == 'rtl' ? 'هل أنت متأكد أنك تريد تعديل هذا المشروع؟' : 'Are you sure you want to edit this project?'}}</span>
    </div>
    <ng-template pTemplate="footer">
        <div class="flex justify-content-end gap-2">
            <p-button [label]="dir == 'rtl' ? 'إلغاء' : 'Cancel'" (onClick)="cancelEdit()" [outlined]="true" severity="secondary"></p-button>
            <p-button [label]="dir == 'rtl' ? 'تأكيد' : 'Confirm'" (onClick)="confirmEdit()" severity="primary"></p-button>
        </div>
    </ng-template>
</p-dialog>